import {Badge} from "@mantine/core"
import {
    Account,
    AccountStatus
} from "../types.ts";

export const AccountStatusBadge = ({record}: { record: Account }) => {

    if (record.accountStatus === AccountStatus.ACTIVE) {
        return <Badge color={'green'}>Active</Badge>;
    } else if (record.accountStatus === AccountStatus.SUSPENDED) {
        return <Badge color={'red'}>Suspended</Badge>
    }
    
    return <Badge color={'gray'}>Unknown</Badge>;
}
